import { Label, RadioGroup, RadioGroupItem } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function RadioGroupDemo() {
  return (
    <Section
      id="radio-group"
      title="RadioGroup"
      description="Mutually-exclusive selection group."
    >
      <VariantBlock label="Default">
        <RadioGroup defaultValue="comfort">
          <div className="flex items-center gap-2">
            <RadioGroupItem value="strict" id="density-strict" />
            <Label htmlFor="density-strict">Strict (compact)</Label>
          </div>
          <div className="flex items-center gap-2">
            <RadioGroupItem value="comfort" id="density-comfort" />
            <Label htmlFor="density-comfort">Comfort (default)</Label>
          </div>
          <div className="flex items-center gap-2">
            <RadioGroupItem value="spacious" id="density-spacious" />
            <Label htmlFor="density-spacious">Spacious</Label>
          </div>
        </RadioGroup>
      </VariantBlock>

      <VariantBlock label="Disabled item">
        <RadioGroup defaultValue="a">
          <div className="flex items-center gap-2">
            <RadioGroupItem value="a" id="rg-a" />
            <Label htmlFor="rg-a">Option A</Label>
          </div>
          <div className="flex items-center gap-2">
            <RadioGroupItem value="b" id="rg-b" disabled />
            <Label htmlFor="rg-b">Option B (disabled)</Label>
          </div>
        </RadioGroup>
      </VariantBlock>
    </Section>
  );
}
